import React, { ComponentProps } from "react";
import Header from "./components/Header";
const Title = ({
  className,
  children,
  ...rest
}: ComponentProps<"div">) => <div className={className} {...rest} data-sentry-component="Title" data-sentry-source-file="index.tsx">
    {children}
  </div>;
Title.Header = Header;
export default Title;